import { computed, ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3bac4318"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-panel"
};
const _hoisted_2 = {
  class: "filter-scroll"
};
const _hoisted_3 = {
  class: "date-presets-footer"
};
const _hoisted_4 = {
  class: "filter-actions"
};
import dayjs from 'dayjs';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { searchFields } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'Filter',
  props: {
    modelValue: null,
    loading: {
      type: Boolean
    },
    options: null,
    quickRanges: null
  },
  emits: ["update:modelValue", "search", "reset"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const localForm = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });
    // a-select 下拉浮层默认挂载到 body，会随页面滚动产生"飞"的视觉跳动；锚定到 trigger 的父节点
    const popupContainer = ref();
    // 被诉产品下拉：使用产品管理同款 ProductSelect，数据沿用现有 productOptions 接口
    // 等接口拉完 productOptions（从 [] 变为真实数据）再喂给下拉组件，避免提前 init 空数组
    const productSelectRef = ref(null);
    watch(() => props.options.productOptions, list => {
      var _productSelectRef$val;
      if (!(list !== null && list !== void 0 && list.length)) return;
      (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(list);
    });
    const datePickerOpen = ref(false);
    const dateValue = computed(() => {
      const [start, end] = localForm.value.complaintTime || [];
      if (!start && !end) return undefined;
      return [start ? dayjs(start) : null, end ? dayjs(end) : null];
    });
    const handleDateChange = values => {
      if (!values) {
        localForm.value.complaintTime = [];
        return;
      }
      localForm.value.complaintTime = [values[0] ? values[0].format('YYYY-MM-DD') : '', values[1] ? values[1].format('YYYY-MM-DD') : ''];
    };
    const applyDatePreset = value => {
      handleDateChange(value);
      datePickerOpen.value = false;
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        layout: "vertical",
        model: _unref(localForm),
        onFinish: _cache[9] || (_cache[9] = $event => emit('search'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form_item, {
          class: "date-filter-item",
          label: "投诉时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_range_picker, {
            open: datePickerOpen.value,
            "onUpdate:open": _cache[0] || (_cache[0] = $event => datePickerOpen.value = $event),
            class: "complaint-date-picker",
            "popup-class-name": "complaint-date-picker-popup",
            value: _unref(dateValue),
            format: "YYYY-MM-DD",
            style: {
              "width": "260px"
            },
            onChange: handleDateChange
          }, {
            renderExtraFooter: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quickRanges, (value, label) => {
              return _openBlock(), _createBlock(_component_a_button, {
                key: label,
                type: "link",
                size: "small",
                onClick: $event => applyDatePreset(value)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(label), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128))])]),
            _: 1
          }, 8, ["open", "value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(localForm).orderKeyword,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => _unref(localForm).orderKeyword = $event),
            valueModifiers: {
              trim: true
            },
            "allow-clear": "",
            placeholder: "DBT订单号/平台订单号",
            style: {
              "width": "190px"
            },
            onPressEnter: _cache[2] || (_cache[2] = $event => emit('search'))
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "问题描述"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(localForm).problemCodes,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => _unref(localForm).problemCodes = $event),
            mode: "multiple",
            "allow-clear": "",
            placeholder: "选择问题",
            style: {
              "width": "190px"
            },
            options: __props.options.problemOptions,
            "max-tag-count": 1,
            "get-popup-container": triggerNode => popupContainer.value || triggerNode.parentNode
          }, null, 8, ["value", "options", "get-popup-container"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "投诉单状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(localForm).complaintStates,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => _unref(localForm).complaintStates = $event),
            mode: "multiple",
            "allow-clear": "",
            placeholder: "选择状态",
            style: {
              "width": "170px"
            },
            options: __props.options.complaintStateOptions,
            "max-tag-count": 1,
            "get-popup-container": triggerNode => popupContainer.value || triggerNode.parentNode
          }, null, 8, ["value", "options", "get-popup-container"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "退款状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(localForm).refundStates,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => _unref(localForm).refundStates = $event),
            mode: "multiple",
            "allow-clear": "",
            placeholder: "全部状态",
            style: {
              "width": "180px"
            },
            options: __props.options.refundStateOptions,
            "max-tag-count": 1,
            "get-popup-container": triggerNode => popupContainer.value || triggerNode.parentNode
          }, null, 8, ["value", "options", "get-popup-container"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "被诉商户"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(localForm).complainedMerchantIds,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => _unref(localForm).complainedMerchantIds = $event),
            mode: "multiple",
            "allow-clear": "",
            placeholder: "选择商户",
            style: {
              "width": "190px"
            },
            options: __props.options.merchantOptions,
            "max-tag-count": 1,
            "get-popup-container": triggerNode => popupContainer.value || triggerNode.parentNode
          }, null, 8, ["value", "options", "get-popup-container"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "被诉产品"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            modelValue: _unref(localForm).complainedProductIds,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(localForm).complainedProductIds = $event),
            multiple: true,
            "show-select-all": true,
            "search-fields": _unref(searchFields),
            "max-tag-count": 1,
            "allow-clear": true,
            "show-detail": false,
            "show-extra": false,
            width: 190,
            placeholder: "选择产品"
          }, null, 8, ["modelValue", "search-fields"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
          onClick: _cache[8] || (_cache[8] = $event => emit('reset'))
        }, {
          default: _withCtx(() => [_createTextVNode("重置")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          "html-type": "submit",
          loading: __props.loading
        }, {
          default: _withCtx(() => [_createTextVNode("查询")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});